(function() {
    // Use const for better performance and prevent accidental reassignment
    const invalidPagesForNonB2b = [
        '/projects',
        '/search',
        '/cart',
    ];
    
    // Get the current path once and cache it
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const urlParams = new URLSearchParams(currentSearch);
    const token = urlParams.get('token');
    
    // Use a more efficient loop with early termination
    // This is faster than .some() for small arrays and allows early exit
    for (let i = 0; i < invalidPagesForNonB2b.length; i++) {
        if (currentPath.includes(invalidPagesForNonB2b[i])) {
            // Build return URL with token if it exists
            let returnUrl = '/pages/configurators';
            if (token && currentPath.includes('/projects')) {
                returnUrl = `/pages/projects?token=${encodeURIComponent(token)}`;
            }
            
            // Use replace() instead of href for faster redirection
            window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(returnUrl)}`;
            return; // Early exit to prevent further execution
        }
    }
})();

